import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { CHECKOUT_STEP, ROUTER_PATH } from "../../common/constant";
import { IShoppingCart } from "../../models/IShoppingCartModel";
import { localizeRouteKey, renderTotalAmount } from "../../shared/helpers";
import InputVoucherCode from "./inputVoucherCode";
interface IShoppingCartSummaryProps {
  carts: IShoppingCart;
  handleChangeVoucherCode: Function;
  handleChangeReferralCode: Function;
  t: any;
  history: any;
  isExpiredVoucherCode: boolean;
}

const ShoppingCartSummary = (props: IShoppingCartSummaryProps) => {
  const { t, carts, handleChangeVoucherCode, isExpiredVoucherCode } = props;
  const [hasDiscount, setHasDiscount] = useState<boolean>(false);

  useEffect(() => {
    if (carts.total_amount_discount) {
      setHasDiscount(true);
    } else {
      setHasDiscount(false);
    }
  }, [carts]);

  return (
    <>
      <div className="shopping-cart-summary-container">
        <div className="shopping-cart-summary-wrapper">
          {!!(
            carts.order_discount_amount && carts.order_discount_amount !== 0
          ) && (
            <div className="shopping-cart-summary-item">
              <span className="shopping-cart-summary-item-sub-label shopping-cart-summary-total-amount sub-title">
                {t("order_discount_amount")}
              </span>
              <span className={`shopping-cart-summary-item-sub-value`}>
                {`-${carts.order_discount_amount.toLocaleString("vi-VN")} VND`}
              </span>
            </div>
          )}
          <div className="shopping-cart-summary-item">
            <span className="shopping-cart-summary-item-label shopping-cart-summary-total-amount main-title">
              {t("shopping_cart_total_amount")}
            </span>
            {hasDiscount ? (
              <del
                className={`shopping-cart-summary-item-value sub-title has-discount`}>
                {carts.sub_total_amount} VND
              </del>
            ) : (
              <span className={`shopping-cart-summary-item-value`}>
                {renderTotalAmount(carts.total_amount)}
              </span>
            )}
          </div>
          <div className="shopping-cart-summary-item">
            <InputVoucherCode
              t={t}
              carts={carts}
              handleChangeVoucherCode={handleChangeVoucherCode}
              isExpiredVoucherCode={isExpiredVoucherCode}
            />
          </div>
        </div>
      </div>
      <div className="shopping-cart-actions-container">
        <Button
          type="default"
          className="kd-btn-default btn-back-to-home"
          onClick={() => props.history.push(localizeRouteKey(ROUTER_PATH.HOME))}
          // href={localizeRouteKey(ROUTER_PATH.HOME)}
        >
          {t("shopping_cart_btn_continue_shopping")}
        </Button>
        <Button
          disabled={isExpiredVoucherCode}
          type="primary"
          className="btn-checkout kd-btn-primary"
          onClick={() =>
            props.history.push(
              localizeRouteKey(ROUTER_PATH.CHECKOUT, [
                t(CHECKOUT_STEP.SHIPPING_INFO),
              ])
            )
          }
          // href={localizeRouteKey(ROUTER_PATH.CHECKOUT, [
          //   t(CHECKOUT_STEP.SHIPPING_INFO),
          // ])}
        >
          {t("shopping_cart_checkout_button")}
        </Button>
      </div>
    </>
  );
};
export default ShoppingCartSummary;
